<template>
  <div v-if="visible" class="customl-modal-overlay" @click.self="close">
    <div class="customl-modal-container">
      <!-- Header -->
      <div class="customl-modal-header">
        <div class="customl-modal-title">
          <i class="bx bx-wallet mr-2"></i>
          {{ getTranslations('expression_691') }}
        </div>
        <button class="customl-close-button" @click="close">
          <i class="bx bx-x"></i>
        </button>
      </div>
      
      <!-- Body -->
      <div class="customl-modal-body">
        <div class="customl-form-group">
          <label>{{ getTranslations('expression_12') }}</label>
          <select v-model="form.department_id" @change="form.main_operator_id = null" class="customl-select">
            <option :value="null">{{ getTranslations('expression_124') }}</option>
            <option
              v-for="dep in getDepartmentsArray('channel_id', lead.channel_id)"
              :key="dep.id"
              :value="dep.id">
              {{ dep.name }}
            </option>
          </select>
        </div>
        
        <div v-if="form.department_id" class="customl-form-group">
          <label>{{ getTranslations('expression_48') }}</label>
          <select v-model="form.main_operator_id" class="customl-select">
            <option :value="null">{{ getTranslations('expression_692') }}</option>
            <option
              v-for="operator in getOperatorsArray('department_id', form.department_id)"
               v-if="[0,1].includes(getUserObject('id', operator.user_id).role_key)"
              :key="operator.id"
              :value="operator.id">
              {{ getUserObject('id', operator.user_id).name }}
            </option>
          </select>
        </div>
      </div>
      
      <!-- Footer -->
      <div class="customl-modal-footer">
        <button 
          class="customl-btn primary"
          :disabled="!form.department_id || !form.main_operator_id"
          @click="submit">
          {{ getTranslations('expression_693') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ModalWallet",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    lead: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        main_operator_id: null,
        department_id: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getUserObject",
      "getDepartmentsArray",
      "getOperatorsArray",
      "getTranslations",
    ]),
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetForm();
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      const payload = {
        ...this.form,
        lead_id: this.lead.id,
        channel_id: this.lead.channel_id,
      };
      this.$store.dispatch("addWallet", payload);
      this.close();
    },
    resetForm() {
      this.form = {
        main_operator_id: null,
        department_id: null,
      };
    },
  },
};
</script>

<style scoped>
.customl-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.customl-modal-container {
  width: 100%;
  max-width: 500px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}
.customl-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #eee;
}
.customl-modal-title {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #333;
}
.customl-close-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
.customl-modal-body {
  padding: 20px 24px;
}
.customl-form-group {
  margin-bottom: 1rem;
}
.customl-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}
.customl-modal-footer {
  padding: 16px 24px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #eee;
}
.customl-btn.primary {
  background-color: #13c2c2;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.customl-btn.primary:disabled {
  background-color: #d9d9d9;
  cursor: not-allowed;
}
</style>
